<template>
	<!-- 新增好友列表 -->
	<div style="background-color: #eee">
		<footer>
			 <!-- @keyup.native="onkeyup($event)" -->
			<el-input class="search" placeholder="搜索" v-model="friendId" @keyup.enter.native="onkeyup">
				<el-button slot="append" icon="el-icon-search" @click="onkeyup"></el-button>
			</el-input>
		</footer>
		<ul style="height:calc(100% - 62px);">
			<li class="lititle">{{!friendId ? '新的朋友' : '添加朋友'}}</li>
			<li @click="showFriend" v-if="!friendId">
				<img class="avatars" width="30" height="30" :src="require('@/assets/images/newfriends.png')">
				<p class="name">新的朋友</p>
			</li>
			<li v-else v-for="(item,index) in userList" :class="{fontcolor:activeIndex == index}" :key="index" @click="showFriendDialog(item,index)">
				<img class="avatars" width="30" height="30" :src="item.headportrait?item.headportrait:'../../../build/logo.png'">
				<p class="name">{{item.usernickname}}</p>
			</li>
			<!-- 按首字母分类过的好友 -->
			<div v-if="!showSearch || !friendId" style="height: calc(100% - 105px);overflow: auto;border-bottom: 1px solid #999;">	
				<template v-for="item in friends">
					<li class="lititle">{{item.initial}}</li>
					<li v-for="(fd,j) in item.data" :key="j" @click="$emit('showmemo',fd)">
						<img class="avatars" width="30" height="30" :src="fd.friendHeadportrait?fd.friendHeadportrait:'../../../build/logo.png'">
						<p class="name">{{fd.friendMemo?fd.friendMemo:fd.usernickname}}</p>
					</li>
				</template>
			</div>
			<!-- 从已经有的好友中搜索出来的内容 -->
			<template v-if="showSearch && friendId">
				<li class="lititle">通讯录</li>
				<li v-for="(fr,f) in searchFriends" :key="f" @click="$emit('showmemo',fr)">
					<img class="avatars" width="30" height="30" :src="fr.friendHeadportrait?fr.friendHeadportrait:'../../../build/logo.png'">
					<p class="name">{{fr.friendMemo?fr.friendMemo:fr.usernickname}}</p>
				</li>
			</template>

		</ul>
		<!-- 申请添加好友弹框 -->
		<el-dialog 
			:visible.sync="dialogVisible"
      width="30%"
      :modal="false">
      <ul>
      	<li>
					<img class="avatars" width="30" height="30" :src="ApplyFriends.headportrait?ApplyFriends.headportrait:'../../../build/logo.png'">
					<p class="name">{{ApplyFriends.usernickname}}</p>
				</li>
      </ul>
      <el-input
			  type="textarea"
			  :rows="2"
			  placeholder="备注"
			  v-model="textarea">
			</el-input>
			<span slot="footer" class="dialog-footer">
		    <el-button size="mini" @click="applyFriend">申请添加为好友</el-button>
		  </span>
		</el-dialog>
	</div>
</template>

<script>
	export default{
		data(){
			return {
				showSearch:false,
				friendId:'',
				lastTimeStamp: 0, //标记当前事件函数的时间戳
				userList:[], // 好友列表数据
				dialogVisible:false, // 申请好友弹框显示状态
				ApplyFriends:{}, // 要添加的好友信息
				textarea:'',
				activeIndex:null,
				friends:[],
				searchFriends:[],
				searchFriend:[]
			}
		},
		watch:{
			friendId(){
				if(this.friendId){
					this.showSearch = true
					// 从通讯录中筛选符合条件的好友
					this.searchFriends = []
					// 模糊查询
					this.searchFriend.forEach(item => {
						if(item.friendMemo){
							if(item.friendMemo.split(this.friendId).length>1){
								this.searchFriends.push(item)
							}
						}else if(item.usernickname){
							if(item.usernickname.split(this.friendId).length>1){
								this.searchFriends.push(item)
							}
						}
					})
				}else{
					this.userList = []
				}
			}
		},
		mounted(){
			this.showFriends()
		},
		methods:{
			// 查找新的好友
			showFriend(){
				this.$emit('trigger')
				this.$parent.$refs.friends.find()
			},
			/**
       *张俊娜：2019/12/9
       *描述：申请好友
       *版本：1.0
       */
      applyFriend(){
        /**
         *宋建国：2019/12/9
         *描述：查询此用户是否已经是好友
         *版本：1.0
         */
        this.$api.im.RelationshipQuery({
          querys: [
            {
              "hasInitValue": true,
              "operation": "EQUAL",
              "property": "mainUserId",
              "relation": "AND",
              "value": sessionStorage.getItem('chatid')
            },
            {
              "hasInitValue": true,
              "operation": "EQUAL",
              "property": "friendUserId",
              "relation": "AND",
              "value": this.friendId
            }
          ]
        }).then((res)=>{
          if(res.data.rows.length>0){
            this.$message.info(this.nickname+"用户已经加为好友");
            this.dialogVisible = false;
            return;
          }
          this.$api.im.addFriend({
            topic: this.$topic.$IMNEWS,
            messageType: this.$topic.$MESSAGETYPE.ApplyFriend,
            toUserId:this.ApplyFriends.id,
            toUserNickName: this.ApplyFriends.username,
            messageString: this.textarea,
            fromUserId:sessionStorage.getItem('chatid')
          }).then(res => {
          	
          }).catch(err => {
          	this.$message.error(err.message)
          })
          this.dialogVisible = false;
        }).catch((error)=>{
          this.$message.error(error.message);
        });
      },
      /**
       *张俊娜：2019/12/10
       *描述：搜索好友
       *版本：1.0
       */
      onkeyup(event){
				if(this.friendId){
					// 查询好友
					this.axios({
						url:this.zuul+'/xyj-im/r/imUsertable/queryNewFriends',
						method:'post',
						params:{
							fromUserId:sessionStorage.getItem('chatid'),
							param:this.friendId
						}
					}).then(res => {
						this.userList = res.data.rows
					}).catch(err => {
						this.$message.error(err.message)
					})
				}
			},
			// 显示申请添加好友弹框
      showFriendDialog(item,index){
				this.activeIndex = index
      	this.ApplyFriends = item;
      	this.dialogVisible = true;
			},
			// 查找好友列表
			showFriends(){
				this.$api.im.FindFriend().then(res => {
					this.searchFriend = JSON.parse(JSON.stringify(res.data))
					this.friends = this.formatterSort(JSON.parse(JSON.stringify(res.data)),'usernickname')
				}).catch(err => {
					this.$message.error(err.message)
				})
			},
			// 按字母分类
			formatterSort(arr,name){
				if(arr.length == 0) return;
        if (!String.prototype.localeCompare) return null;
        var letters = "*ABCDEFGHJKLMNOPQRSTWXYZ".split("");
        var zh = "阿八嚓哒妸发旮哈讥咔垃痳拏噢妑七呥扨它穵夕丫帀".split("");
        var segs = []; // 存放数据
        var res = {};
        let curr;
        var re = /[^\u4e00-\u9fa5]/;//中文正则
        var pattern = new RegExp("[`\\-~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？12345678990]"); //特殊符号

        letters.filter((items, i) => {
          curr = {
              initial: '', //字母
              data: [] ,  //数据
            };
          arr.map((v, index) => {
            // 特殊字符
            if (pattern.test(v[name][0])) {
              if ((!zh[i - 1] || zh[i - 1].localeCompare(v[name]) <= 0) && v[name].localeCompare(zh[i]) == -1) {
                curr.data.push(v);
              }
            }
            // 判断首个字是否是中文 
            if (re.test(v[name][0])) {
              // 英文 
              if (v[name][0].toUpperCase() == items) {
                curr.data.push(v);
              }
            } else {
              // 中文
              if ((!zh[i - 1] || zh[i - 1].localeCompare(v[name]) <= 0) && v[name].localeCompare(zh[i]) == -1) {
                curr.data.push(v);
              }
            }

          })

            if ( curr.data.length) {
              curr.initial = letters[i]
              segs.push(curr);
              curr.data.sort((a, b) => {
                return a[name].localeCompare(b[name]);
              });             
            }
        })
        res.segs = Array.from(new Set(segs)) //去重
        return res.segs;
			}
		}
	}
</script>

<style scoped>
	ul{
		margin: 0;
		padding: 0;
	}
	li {
		display: flex;
		align-items: center;
	  padding: 12px 15px;
	  cursor: pointer;
	  transition: background-color .1s;
	  list-style: none;
	}
	li:hover{
		background-color: #DDDBDA;
	}
	.lititle:hover{
		background-color: transparent;
	}
	.lititle{
		height: 14px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #999999;
	}
	.active {
	  background-color: rgba(88, 88, 88, 0.1);
	}
	.avatars,
	.name {
	  vertical-align: middle;
	}
	.avatars {
		width: 40px;
		height: 40px;
	  border-radius: 2px;
	}
	.name {
	  display: inline-block;
	  margin: 0 0 0 15px;
	}
	footer {
  padding: 15.5px 12px;
  border-bottom: 1px solid #ccc;
}
.search /deep/ input {
	width: 100%;
	font-size: 12px;
	color: #000;
	height: 30px;
	line-height: 30px;
	border: solid 1px #DBD9D8;
	border-radius: 4px;
	outline: none;
	background-color: #DBD9D8;
	box-sizing: border-box;
}
.search /deep/ .el-input__prefix > .el-input__icon{
	line-height: 30px;
}
.fontcolor{
	background-color: #C5C5C5;
}
</style>


// WEBPACK FOOTER //
// src/components/vueChart/card.vue